const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
    VIDEOS: "videos",
    COMMENTS: "comments",
    AUTOMATIONS: "automations",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("youtubeChannel.detail") || "Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: false,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("youtubeChannel.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VIDEOS,
        label: that?.$t("youtubeChannel.videos") || "Videos",
        icon: {
            type: "material-icons",
            name: "video_library",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.COMMENTS,
        label: that?.$t("youtubeChannel.comments") || "Comments",
        icon: {
            type: "material-icons",
            name: "comment",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.AUTOMATIONS,
        label: "Automations",
        icon: {
            type: "component",
            name: "AutomationIcon",
            class: "myIcon",
            style: { fill: "var(--color-icon-primary-default)" },
        },
    }
];

export default {
    MENU_TYPES,
    Items,
};
